module.exports = __webpack_public_path__ + "img/send.a98938f4.svg";